import { render, staticRenderFns } from "./IconChevron.vue?vue&type=template&id=9fa98656&scoped=true&"
import script from "./IconChevron.vue?vue&type=script&lang=js&"
export * from "./IconChevron.vue?vue&type=script&lang=js&"
import style0 from "./IconChevron.vue?vue&type=style&index=0&id=9fa98656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa98656",
  null
  
)

export default component.exports